module.exports = __webpack_public_path__ + "img/FLO-alt.3a401b16.svg";